import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Link, useNavigate } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import { RootState } from '../../store/GlobalStore'
import style from '../../styles/pages/account/Info.module.scss'
import { useTranslation } from 'react-i18next';
/*import {
    ModifyLesseeFormData,
    UserUpdateResponse,
    MediaUploadResponse
} from '../../utils/Interface'
import { useUpdateMutation } from '../../services/UserAPI'
import { useUploadMutation } from '../../services/MediaAPI'
import { setUser } from '../../features/authSlice'
import { addNotification } from '../../features/notificationSlice'
import { FormData } from 'formdata-node'*/
import PageHeader from '../../components/layout/PageHeader'

const InfoPage: React.FC = () => {
    const { t } = useTranslation();
    const authState = useSelector((state: RootState) => state.Auth)
    const [submitted, setSubmitted] = useState(false)
    const dispatch = useDispatch()
    const navigate = useNavigate()

    return (
        <>
            <PageHeader backTo='/mon-compte' title={t('personal_info')} />
            <form
                className={style.ModifyLesseeForm}>
                <div className={`${style.ModifyLesseeFormChild}`}>
                <div className={style.DesktopFormField}>
                        <div className={style.InputContainer}>
                            <div className={style.Label}>{t('code_client')}</div>
                            <div className={style.Data} id='customerCode'>{authState?.user?.customerCode || '-'}</div>
                        </div>
                    </div>
                    <div className={style.DesktopFormField}>
                        <div className={style.InputContainer}>
                            <div className={style.Label}>{t('prenom')}*</div>
                            <div className={style.Data} id='firstname'>{authState?.user?.firstname || '-'}</div>
                        </div>
                        <div className={style.InputContainer}>
                            <div className={style.Label}>{t('nom')}*</div>
                            <div className={style.Data} id='lastname'>{authState?.user?.lastname || '-'}</div>
                        </div>
                    </div>
                    <div className={style.DesktopFormField}>
                        <div className={style.InputContainer}>
                            <div className={style.Label}>{t('email')}*</div>
                            <div className={style.Data} id='email'>{authState?.user?.email || '-'}</div>
                        </div>
                        <div className={style.InputContainer}>
                            <div className={style.Label}>{t('portable')}*</div>
                            <div className={style.Data} id='phone'>{authState?.user?.phone || '-'}</div>
                        </div>
                    </div>
                    <div className={style.DesktopDateField}>
                        <div className={style.InputContainer}>
                            <div className={style.Label}>{t('date_de_naissance')}</div>
                            <div className={style.Data} id='birthdate'>{authState?.user?.birth || '-'}</div>
                        </div>
                    </div>
                    <div className={style.DesktopFormField}>
                        <div className={style.InputContainer}>
                            <div className={style.Label}>{t('adresse1')}</div>
                            <div className={style.Data} id='adr1'>{authState?.user?.address1 || '-'}</div>
                        </div>
                        <div className={style.InputContainer}>
                            <div className={style.Label}>{t('adresse2')}</div>
                            <div className={style.Data} id='adr2'>{authState?.user?.address2 || '-'}</div>
                        </div>
                    </div>
                    <div className={style.DesktopFormField}>
                        <div className={style.InputContainer}>
                            <div className={style.Label}>{t('code_postal')}</div>
                            <div className={style.Data} id='postcode'>{authState?.user?.zipCode || '-'}</div>
                        </div>
                        <div className={style.InputContainer}>
                            <div className={style.Label}>{t('ville')}</div>
                            <div className={style.Data} id='city'>{authState?.user?.city || '-'}</div>
                        </div>
                    </div>
                    <div className={style.DesktopFormField}>
                        <div className={style.InputContainer}>
                            <div className={style.Label}>{t('rep')}</div>
                            <div className={style.Data} id='state'>-</div>
                        </div>
                        <div className={style.InputContainer}>
                            <div className={style.Label}>{t('pays')}</div>
                            <div className={style.Data} id='country'>{authState?.user?.country || '-'}</div>
                        </div>
                    </div>
                </div>
                <div className={style.buttonContainer}>
                    <Link to='/create-incidient'>
                        <button className={style.IncidentButton}>{t('modification_request')}</button>
                    </Link>
                </div>
                {/*<div className={style.buttonContainer}>
                    <Link to='/mon-compte'>
                        <button className={style.Cancel}>Annuler</button>
                    </Link>
                    <button
                        type='submit'
                        className={style.Update}>
                        Modifier
                    </button>
                </div>*/}
            </form>
        </>
    )
}

export default InfoPage
